/**
 * GLAMRDiP Reviews page — filter pills.
 * Joel 2026-04-29.
 *
 * Single-select pill filter on the masonry grid: clicking a pill
 * (`data-gd-filter="<category>"`) hides every card whose
 * `data-gd-category` doesn't match. "all" shows everything.
 *
 * Lightweight on purpose — no debounce, no animation overhead. CSS
 * `display: none` is the cheapest path to a re-flow that the browser
 * can paint in one frame for ~50 cards.
 */
(() => {
  'use strict';

  document.querySelectorAll('[data-gd-reviews-pgrid]').forEach((root) => {
    const filters = root.querySelectorAll('[data-gd-filter]');
    const cards   = root.querySelectorAll('[data-gd-category]');
    if (!filters.length || !cards.length) return;

    function applyFilter(category) {
      cards.forEach((card) => {
        const matches = category === 'all' || card.getAttribute('data-gd-category') === category;
        // Clear inline display so the masonry CSS column flow re-flows
        // immediately. `style.display = ''` is a property remove, not
        // an empty string assignment in the cascade sense.
        card.style.display = matches ? '' : 'none';
      });
    }

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        const category = btn.getAttribute('data-gd-filter') || 'all';
        filters.forEach((b) => {
          const isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        applyFilter(category);
      });
    });
  });
})();
